import { observable, action, computed } from 'mobx';
import { IBorrowerDto } from '../models/dtos/borrower';
import { BorrowerApi } from '../apis/borrowerApi';

export class BorrowerStore {
  @observable
  borrower: IBorrowerDto | undefined = undefined;

  borrowerApi = new BorrowerApi();

  @action
  setBorrower(borrower: IBorrowerDto) {
    this.borrower = borrower;
  }
  @computed
  get hasBorrower() {
    return !!this.borrower;
  }

  async setBorrowerStoreValue() {
    if (!this.hasBorrower) {
      const borrower = await this.borrowerApi.getBorrower();
      this.setBorrower(borrower);
    }
  }
}
